var XMLFile = require("../xml/XMLFile");

/**
 * This class represents the core.xml within the generated Excel. The
 * Core contains basic information about the content and the owner of
 * the file.
 *
 * @param {Object} [oContext] - Context object containing metadata for this particular Excel
 * @param {string} [oContext.title] - Title of the Excel document
 * @param {string} [oContext.modifiedBy] - User context for the exported document
 * @constructor
 */
function Core(oContext) {
	XMLFile.call(this, Core.metadata);

	if (oContext) {

		if (oContext.title) {
			this.title.value = oContext.title;
		}

		if (oContext.modifiedBy) {
			this.modifiedBy.value = oContext.modifiedBy;
		}
	}
}

Core.prototype = Object.create(XMLFile.prototype);
Core.prototype.constructor = Core;

Core.metadata = {
	path: "docProps/",
	filename: "core.xml",
	tag: "cp:coreProperties",
	root: true,
	attributes: [
		{
			name: "xmlns",
			suffix: "cp",
			value: "http://schemas.openxmlformats.org/package/2006/metadata/core-properties"
		},
		{
			name: "xmlns",
			suffix: "dc",
			value: "http://purl.org/dc/elements/1.1/"
		},
		{
			name: "xmlns",
			suffix: "dcterms",
			value: "http://purl.org/dc/terms/"
		},
		{
			name: "xmlns",
			suffix: "dcmitype",
			value: "http://purl.org/dc/dcmitype/"
		},
		{
			name: "xmlns",
			suffix: "xsi",
			value: "http://www.w3.org/2001/XMLSchema-instance"
		}
	],
	properties: [
		{
			id: "title",
			tag: "dc:title",
			value: "Table Export" // Default value, can be overridden
		},
		{
			tag: "dc:creator",
			value: "SAP UI5 Document Export"
		},
		{
			tag: "cp:keywords",
			value: "SAP UI5 EXPORT"
		},
		{
			id: "modifiedBy",
			tag: "cp:lastModifiedBy",
			value: "SAP UI5" // Default value, can be overridden
		},
		{
			tag: "dcterms:created",
			attributes: [
				{
					prefix: "xsi",
					name: "type",
					value: "dcterms:W3CDTF"
				}
			],
			value: new Date().toISOString()
		},
		{
			id: "modified",
			tag: "dcterms:modified",
			attributes: [
				{
					prefix: "xsi",
					name: "type",
					value: "dcterms:W3CDTF"
				}
			],
			value: new Date().toISOString()
		}
	]
};

/**
 * Updates the state of the Core class and returns the serialized string.
 *
 * @return {string} - Serialized representation of the Core instance
 */
Core.prototype.serialize = function() {
	this.modified.value = new Date().toISOString();

	return Object.getPrototypeOf(Core.prototype).serialize.call(this);
};

module.exports = Core;